module.exports = __webpack_public_path__ + "img/广告位2.eb4f8575.png";